import React from 'react';
import { canonicalFor, usePageMeta } from '../../hooks/usePageMeta';
import { PageHeader } from '../../components/page/PageHeader';
import { ContentSection } from '../../components/page/ContentSection';
import { SpecList } from '../../components/page/SpecList';
import { CatalogTable } from '../../components/page/CatalogTable';
import { CautionNote } from '../../components/page/CautionNote';
import { TechAssistCallout } from '../../components/page/TechAssistCallout';
import { RelatedLinks } from '../../components/page/RelatedLinks';
import { catalog } from '../../data/catalog';
export function Titanium() {
  usePageMeta({
    title: 'Titanium Starting Guidance: APGX DR80 Inserts | Robertson Precision',
    description: 'Shear Geometry APGX 331R and 332R DR80 honed, MAX-coated inserts for titanium, with a suggested 100–200 SFM, .003–.007 IPR starting range.',
    canonical: canonicalFor('/applications/titanium/')
  });
  return <>
      <PageHeader eyebrow="Applications" title="Turning Titanium" lead="Honed, MAX-coated DR80 inserts carry a more conservative suggested starting range for titanium." crumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Applications',
      href: '/applications/'
    }, {
      label: 'Titanium'
    }]} data-id="element-731" data-mp="3uzv3qgu3jh8j" />

      <ContentSection id="inserts" title="DR80 inserts" data-id="element-732" data-mp="2y8ze4wulluvq">
        <CatalogTable rows={catalog.filter(c => c.family === 'dr80')} caption="DR80 inserts for titanium" variant="inserts" data-id="element-733" data-mp="3vvolznbzf1pi" />
      </ContentSection>

      <ContentSection id="range" tone="warm" title="Suggested starting range" data-id="element-734" data-mp="3qusmdlyny1pw">
        <SpecList ariaLabel="Titanium suggested starting range" specs={[{
        label: 'Speed',
        value: '100–200 SFM'
      }, {
        label: 'Feed',
        value: '.003–.007 IPR'
      }, {
        label: 'DOC per side',
        value: 'Up to .400 in'
      }, {
        label: 'Inserts',
        value: '331R / 332R DR80'
      }]} data-id="element-735" data-mp="3hvxem5fz0jkh" />
        <div className="mt-8" data-id="element-736" data-mp="27z8qg420b34u">
          <CautionNote title="Application-dependent" data-id="element-737" data-mp="27w31qpxai39n">
            <p data-id="element-738" data-mp="2cvz7atlmy2rb">
              No specific titanium alloy or test conditions were supplied with
              this range. The upper depth of cut is the top of the published
              range, not a safe setting for every titanium part, machine or
              setup. Start conservatively and confirm with the technical staff.
            </p>
          </CautionNote>
        </div>
      </ContentSection>

      <ContentSection id="help" data-id="element-739" data-mp="1tyxzl10p5ojo">
        <TechAssistCallout location="titanium" data-id="element-740" data-mp="1u094531yv0bu" />
      </ContentSection>

      <RelatedLinks links={[{
      label: 'Inserts & Chipbreakers',
      href: '/products/inserts/',
      description: 'MG12 and DR80 are different grades.'
    }, {
      label: 'Tool Selection',
      href: '/technical-resources/tool-selection/',
      description: 'Holder, insert and application.'
    }, {
      label: 'Workholding & Safety',
      href: '/technical-resources/safety/',
      description: 'Setup checks before cutting.'
    }, {
      label: 'Starting Data',
      href: '/technical-resources/starting-data/',
      description: 'All materials in one table.'
    }]} data-id="element-741" data-mp="1fal4055iu7pp" />
    </>;
}